import { api } from './api'
import { authClient } from './auth'
import { forgetFamily } from './frame'
import { forgetOfflineCopies } from './offline'

export async function signOut() {
  // Signing out while viewing as a test person ends that too, so the next sign-in starts as yourself.
  await api('/view-as', { method: 'DELETE' }).catch(() => {})
  await authClient.signOut()
  await forgetOfflineCopies()
  forgetFamily()
  // A full reload forgets everything held in memory for this person.
  window.location.assign('/')
}
